import { NavLink } from 'react-router-dom';

const GALLERY_CARD = (props) => {

    const titleWithoutDashes = props.Title.replace(/\s-/g, '');
    const titleWithoutSpaces = titleWithoutDashes.replace(/\s/g, '-');
    const modifiedTitle = titleWithoutSpaces.toLowerCase();
    // console.log(modifiedTitle);

    return (

        <section className="project" role="link" tabIndex="0">

                <NavLink to={`/gallery/${modifiedTitle}`} className="card-container">
                <img src={props.CardImage} alt={props.Title}></img>
                <div className="card-title">{props.Title}</div>
                </NavLink>

        </section>
    );
};

export default GALLERY_CARD;